/**
 * What the nightly and hourly jobs left for this venue (#81), and the button
 * that clears one.
 *
 * The notices arrive already filtered and in order — the API applies
 * `activeNotices` from @baros/core — so a screen that shows them only has to
 * draw them. Clearing one clears it for everybody at the venue.
 */

import type { Notice } from "@baros/core";
import { request } from "../api.js";

const v = (venueId: string) => encodeURIComponent(venueId);

export const noticesApi = {
  list: (token: string, venueId: string) =>
    request<{ notices: Notice[] }>(token, "GET", `/v1/venues/${v(venueId)}/notices`),

  /** The id carries `#`, which a path has to escape or the browser takes it for a fragment. */
  dismiss: (token: string, venueId: string, noticeId: string) =>
    request<{ dismissed: string }>(
      token,
      "POST",
      `/v1/venues/${v(venueId)}/notices/${encodeURIComponent(noticeId)}/dismiss`,
    ),
};
